import TableSidePanel from 'components/table/TableSidePanel';
import { RoundActionLogEntry } from 'types/game';

interface DesktopRightSidebarProps {
  actions?: RoundActionLogEntry[];
  roundNumber?: number;
  currencySymbol?: string;
  currencyCode?: string | null;
}

/** Desktop round log rail — chat is opened from the hero seat control. */
export default function DesktopRightSidebar({
  actions = [],
  roundNumber = 0,
  currencySymbol,
  currencyCode,
}: DesktopRightSidebarProps) {
  return (
    <TableSidePanel
      actions={actions}
      roundNumber={roundNumber}
      currencySymbol={currencySymbol}
      currencyCode={currencyCode}
    />
  );
}
